import type { ReactElement } from "react";
import { Icon } from "../ui/Icon/Icon";
import { UserMenu } from "./UserMenu";
import styles from "./MobileAppBar.module.css";

export interface MobileAppBarProps {
  title: string;
  currentPath: string;
  onSignOut: () => void;
  onMenu: () => void;
  onAccount?: () => void;
  showBack?: boolean;
  onBack?: () => void;
}

export function MobileAppBar({
  title,
  currentPath,
  onSignOut,
  onMenu,
  onAccount,
  showBack = false,
  onBack,
}: MobileAppBarProps): ReactElement {
  return (
    <header className={styles.bar} data-sticky-top>
      {showBack ? (
        <button
          type="button"
          className={styles.iconButton}
          onClick={onBack}
          aria-label="Back"
        >
          <Icon name="back" size={24} />
        </button>
      ) : (
        <button
          type="button"
          className={styles.iconButton}
          onClick={onMenu}
          aria-label="Open menu"
        >
          <Icon name="menu" size={24} />
        </button>
      )}
      <h1 className={styles.title}>{title}</h1>
      <UserMenu
        key={currentPath}
        onSignOut={onSignOut}
        onAccount={onAccount}
        compact
      />
    </header>
  );
}
